<template>
  <Select
    v-model="selectedBrand"
    @onSearch="onSearch"
    @onSelect="onSelect"
    @onClear="onClear"
    :options="getOptions"
    title="Marka Seçimi"
    placeholder="Marka Seçimi"
    v-readonly
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>
<script>
import brandService from '@/services/brand';
import Select from '@/components/Select';

export default {
  name: 'BrandSelect',
  components: { Select },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    supplierProductQueryType: {
      type: [String, null],
      default: null,
    },
  },
  data () {
    return {
      brandOptions: [],
      inputValue: '',
      brand: {},
    };
  },
  computed: {
    getOptions () {
      const value = this.inputValue;
      return this.brandOptions
        .filter(item => item.name.toString().toLocaleLowerCase('tr-TR').search(value) > -1)
        .map(item => {
          let order = item.name.substr(0, 1).toLocaleLowerCase('tr-TR');
          if (value.length) {
            order = item.name.toLocaleLowerCase('tr-TR').search(value);
          }
          return {
            ...item,
            order,
          };
        }).map(item => ({
          ...item,
          id: item.id,
          label: item.name,
        }))
        .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
        .slice(0, 100);
    },
    selectedBrand: {
      get () {
        return this.value;
      },
      set (val) {
        return val;
      },
    },
  },
  methods: {
    async getBrandBySupplier () {
      const supplierProductQueryType = this.supplierProductQueryType;
      this.brandOptions = await brandService.getBrandBySupplier({ type: supplierProductQueryType });
    },
    onSearch (searchValue) {
      this.inputValue = searchValue.toString().toLocaleLowerCase('tr-TR');
    },
    onSelect (option) {
      this.$emit('input', option);
    },
    onClear () {
      this.$emit('input', {});
    },
  },
  created () {
    this.getBrandBySupplier();
  },
};
</script>
